export enum Variants {
  Outlined = 'outlined',
  Text = 'text',
  Contained = 'contained',
  ContainedLight = 'contained-light',
}

export enum Sizes {
  Large = 'large',
  Medium = 'medium',
  Small = 'small',
}

export enum Colors {
  Primary = 'primary',
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
  Success = 'success',
  White = 'white',
  TextPrimary = 'text-primary',
  TextSecondary = 'text-secondary',
  Inherit = 'inherit',
}
